// removed by extract-text-webpack-plugin
module.exports = {"LoginBox":"_1PAJO43aHge2SRv4lcL4xv","LoginBox--naked":"_2hLuyXhLQ5Cg0UtY1HaUfd","LoginBox__title":"_3tUbSs2FLC8_bg6Rhu1Wg6","LoginBox__signin-button":"_3wFJF_ZxMddAB_sLBwzEde","LoginBox__error":"_1K9qd0S8JWJmqwNGbeQYW7","LoginBox__form-error":"_22YcBmGutuGTrNEkW7-msL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginBox/LoginBox.scss
// module id = 2644
// module chunks = 0